import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import logo from "../assets/logo.svg";
import { TransitionProps } from "@mui/material/transitions";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide direction="down" mountOnEnter={false} appear ref={ref} {...props} />
  );
});

export default function FullScreenDialog() {
  const [open, setOpen] = React.useState(true);
  React.useEffect(
    () => {
      let timer1 = setTimeout(() => setOpen(false), 2000);

      // this will clear Timeout
      // when component unmount like in willComponentUnmount
      // and show will not change to true
      return () => {
        clearTimeout(timer1);
      };
    },
    // useEffect will run only one time with empty []
    // if you pass a value to array,
    // like this - [data]
    // than clearTimeout will run every time
    // this value changes (useEffect re-run)
    []
  );

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition}>
      <Box
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "black",
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={logo} alt="loading-logo" style={{ height: "100px" }}></img>
        <h3>Rebel Tiger Club</h3>
      </Box>
    </Dialog>
  );
}
